import Box from "@material-ui/core/Box"
import Checkbox from "@material-ui/core/Checkbox"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import Radio from "@material-ui/core/Radio"
import Typography from "@material-ui/core/Typography"
import React from "react"
import { HourReportWorkflow } from "../../api"
import { useHourReportWorkflowTranslations } from "./use-translations"

type CheckAndApprovalWorkflowProps = {
  selected: boolean
  disabled: boolean
  reviewRequiresSubmission: boolean
  approvalRequiresChecking: boolean
  onReviewRequiresSubmissionChange: (checked: boolean) => void
  onApprovalRequiresCheckingChange: (checked: boolean) => void
}

const CheckAndApprovalWorkflow = ({
  selected,
  disabled,
  reviewRequiresSubmission,
  approvalRequiresChecking,
  onReviewRequiresSubmissionChange,
  onApprovalRequiresCheckingChange,
}: CheckAndApprovalWorkflowProps) => {
  const translations = useHourReportWorkflowTranslations()

  return (
    <React.Fragment>
      <FormControlLabel
        value={HourReportWorkflow.CheckAndApproval}
        disabled={disabled}
        control={<Radio color="primary" style={{ marginRight: 12, marginTop: -12 }} />}
        label={
          <Box py={0.5}>
            <Typography variant="subtitle1">{translations.checkAndApprovalLabel}</Typography>
            <Typography variant="body2" color="textSecondary">
              {translations.checkAndApprovalDescription}
            </Typography>
          </Box>
        }
      />
      {selected && (
        <Box ml={4} mb={2} mt={1}>
          <FormControlLabel
            style={{ display: "flex" }}
            disabled={disabled}
            control={
              <Checkbox
                checked={reviewRequiresSubmission}
                style={{ marginRight: 8, marginTop: -12 }}
                color="primary"
                onChange={(event) => onReviewRequiresSubmissionChange(event.target.checked)}
              />
            }
            label={
              <Box py={0.5}>
                <Typography variant="subtitle1">{translations.requireSubmissionBeforeReviewLabel}</Typography>
                <Typography variant="body2" color="textSecondary">
                  {translations.requireSubmissionBeforeReviewDescription}
                </Typography>
              </Box>
            }
          />
          <FormControlLabel
            style={{ display: "flex" }}
            disabled={disabled}
            control={
              <Checkbox
                checked={approvalRequiresChecking}
                color="primary"
                style={{ marginRight: 8, marginTop: -12 }}
                onChange={(event) => onApprovalRequiresCheckingChange(event.target.checked)}
              />
            }
            label={
              <Box py={0.5}>
                <Typography variant="subtitle1">{translations.requireCheckingBeforeApprovalLabel}</Typography>
                <Typography variant="body2" color="textSecondary">
                  {translations.requireCheckingBeforeApprovalDescription}
                </Typography>
              </Box>
            }
          />
        </Box>
      )}
    </React.Fragment>
  )
}

export default CheckAndApprovalWorkflow
